import { message } from 'antd';
import { put, select, takeLatest } from 'redux-saga/effects';
import { logger } from 'services';
import { rlNavigation } from 'utils/navigation';
import { updateSpaceInProjectTemplate } from '../../actions';
import { updateProjectTemplateSpace } from '../../slices';
const selectSpace = (id)=>({ templates })=>templates.project.data[templates.project.activeId].spaceList[id];
const selectActiveTemplate = ()=>({ templates })=>templates.project.data[templates.project.activeId].template;
function* updateSpaceInTemplateSaga(action) {
    try {
        const { payload } = action;
        const activeTemplate = yield select(selectActiveTemplate());
        const space = yield select(selectSpace(payload.space.spaceId));
        yield put(updateProjectTemplateSpace(payload.space));
        if (space.isNew) {
            yield rlNavigation.push(`/templates/projects/${activeTemplate.templateId}/spaces/${payload.space.spaceId}/tabs/new`);
        }
    } catch (error) {
        logger.error('an error updating the space', {
            error
        });
        message.error('There was an error updating the space');
    }
}
export function* watchUpdateSpaceInProjectTemplateSaga() {
    yield takeLatest(updateSpaceInProjectTemplate.type, updateSpaceInTemplateSaga);
}
